import { createStyles } from '@mui/styles';
import Cookies from 'js-cookie';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants';
// Constants
import { SSO_CDH_COMPANY_KEY } from '../../../../core/utils/Constants/Constants';

export default (theme: APTheme) =>
  createStyles(
    (() => {
      const logo = (theme.portal && theme.portal.logo) || "";
      const cdhcomapny: string | undefined = Cookies.get(SSO_CDH_COMPANY_KEY) ?? Cookies.get('cdhCompany');

      if (cdhcomapny === 'fcg'){
        const minimisedlogo = (theme.portal && theme.portal.minimisedlogo) || "";
        return {
          affiliateLogo: {
            backgroundSize: "auto 61px",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${logo})`,
            flex: 1,
            height: 61,
            marginLeft: 40
          },
          minified: {
            marginBottom: 16,
            marginLeft: 0,
            marginTop: 20,
            width: 22,
            height:22,
            innerHeight:30,
            backgroundImage: `url(${minimisedlogo})`
          }
        };
      } else{
        return {
          affiliateLogo: {
            backgroundSize: "auto 35px",
            backgroundPosition: "left center",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${logo})`,
            flex: 1,
            height: 38,
            marginLeft: 22
          },
          minified: {
            marginBottom: 20,
            marginLeft: 0,
            marginTop: 20,
            width: 38,
            innerHeight:30
          }
        };
      }

    })()
  );
